import { GridColumnConfig } from "../../../models/gridCoumnConfig";

export const emailLogColumns: GridColumnConfig[] = [
  {
    title: 'Recipient Name',
    field: 'recipientName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Email',
    field: 'recipientEmail',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Mail Sent Status',
    field: 'mailSentStatus',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Mail Sent On',
    field: 'mailSentOn',
    filter: 'text',
    searchable: true,
  },
];
